import { useEffect, useRef, useCallback } from 'react';

const TIMEOUT_MS = 10 * 60 * 1000; // 10 minutos
const EVENTOS = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click'];

/**
 * Cierra sesión automáticamente tras TIMEOUT_MS de inactividad.
 * Solo se activa cuando `activo` es true (uso exclusivo para bomberos).
 *
 * @param {{ activo: boolean, onInactividad: () => void }} opts
 */
export default function useInactividad({ activo, onInactividad }) {
  const timer      = useRef(null);
  const callbackRef = useRef(onInactividad);

  useEffect(() => { callbackRef.current = onInactividad; }, [onInactividad]);

  const reset = useCallback(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => callbackRef.current(), TIMEOUT_MS);
  }, []);

  useEffect(() => {
    if (!activo) return;

    EVENTOS.forEach(ev => window.addEventListener(ev, reset, { passive: true }));
    reset(); // arranca el contador desde ya

    return () => {
      clearTimeout(timer.current);
      EVENTOS.forEach(ev => window.removeEventListener(ev, reset));
    };
  }, [activo, reset]);
}
